<!--
    Styles
-->

<style>


    /* main */

    .p-import {
        position: relative;
        min-width: 540px;
        padding: 40px 35px 35px 35px;
        background: var(--cl-white);
        overflow-x: hidden;
    }

    /* loader */

    .p-import .loader {
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        overflow: hidden;
    }

    /* close */

    .p-import .close {
        position: absolute;
        width: 24px;
        height: 24px;
        top: 16px;
        right: 16px;
    }
    .p-import .close svg {
        fill: var(--cl-gray);
    }

    /* headings */

    .p-import .icon {
        margin: auto;
        margin-bottom: 15px;
        width: 30px;
        height: 30px;
        fill: var(--cl-green);
    }
    .p-import h1 {
        margin: 0 0 20px 0;
    }
    .p-import .caption {
        margin-bottom: 30px;
    }

    /* common */

    .p-import .btn {
        max-width: 220px;
        margin: 0 auto;
    }

    /* upload */

    .p-import .upload label {
        cursor: pointer;
    }
    .p-import .upload input[type="file"] {
        display: none;
    }

    /* select */

    .p-import .select .container {
        width: 370px;
        margin: auto;
    }
    .p-import .select .notice {
        margin-bottom: 20px;
    }
    .p-import .select .ui-dropdown {
        z-index: 1;
        flex: 1 1 auto;
        margin: 10px 0;
    }
    .p-import .select .ui-dropdown .ui-select {
        border: 1px solid var(--cl-gray);
        border-radius: 3px;
        padding: 0 12px;
        height: 42px;
    }
    .p-import .select .ui-dropdown .ui-select.active {
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }
    .p-import .select .ui-dropdown .dropdown {
        background: var(--cl-white);
        max-height: 300px;
        border-top: 0;
        overflow-y: scroll;
    }
    .p-import .select .ui-dropdown .dropdown .option {
        height: 40px;
    }
    .p-import .select .ui-dropdown .dropdown .option:hover {
        background: var(--cl-blue-light);
    }
    .p-import .select .dots {
        display: flex;
        margin: 35px auto;
        justify-content: center;
        flex-wrap: wrap;
    }
    .p-import .select .dots .dot {
        margin: 5px 8px;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background-color: var(--cl-gray);
        cursor: pointer;
        transition-duration: 50ms;
    }
    .p-import .select .dots .dot:hover {
        background-color: var(--cl-gray-light);
    }
    .p-import .select .dots .dot.active {
        background-color: var(--cl-gray-dark);
    }
    .p-import .select .btn {
        max-width: 220px;
        margin: 0 auto;
    }
    .p-import .select .next svg {
        margin: 0;
    }

    /* preview */

    .p-import .carousel {
        height: 360px;
        position: relative;
        margin: 20px 0;
    }
    .p-import .carousel .inner {
        left: 0;
        position: absolute;
        display: flex;
        flex-direction: row;
        transition: all .2s ease-in-out;
    }
    .p-import .preview {
        width: 360px;
        margin: 0 16px;
    }
    .p-import .preview .header {
        color: var(--cl-gray);
    }
    .p-import .preview .header .selected {
        color: var(--cl-gray-dark);
    }
    .p-import .preview .row {
        height: 50px;
        border-bottom: 1px solid var(--cl-gray);
    }
    .p-import .preview .scroll {
        max-height: calc(50px * 5);
        overflow-y: scroll;
    }

    /* complete */

    .p-import .complete .message {
        justify-content: center;
        margin: 20px 0;
    }
    .p-import .complete .message svg {
        width: 20px;
        height: 20px;
        color: #ec0009;
        margin-right: 10px;
    }
    .p-import .complete .errors {
        width: 500px;
        margin: 40px auto 0 auto;
        text-align: left;
    }
    .p-import .complete .errors .error:first-child {
        border-top: 1px solid var(--cl-gray-light);
    }
    .p-import .complete .errors .error {
        padding: 20px 0;
        border-bottom: 1px solid var(--cl-gray-light);
    }
    .p-import .complete .errors .error .indexes {
        margin-top: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .p-import .complete p {
        margin: 20px 0;
    }
    .p-import .complete .finish {
        margin-top: 40px;
    }


</style>



<!--
    Template
-->

<template>
    <div class="p-import" :style="{width}">

        <!-- loader -->

        <div class="loader u-stretch" v-show="!!loading">
            <ui-loader class="ui-loader" />
        </div>

        <!-- close -->

        <a aria-label="閉じる" class="close cl-placeholder" @click="$popup.hide">
            <icon-close />
        </a>

        <icon-success class="icon" v-if="result && succeeded > 0 && !result.failed.length" />

        <h1 class="h2 t-center">{{ title }}</h1>
        <div class="caption t12 t-center" v-show="subtitle">{{ subtitle }}</div>

        <div class="upload" v-if="mode === 'upload'">
            <label for="upfile" class="btn primary">
                <icon-file />
                ファイルを選択する
            </label>
            <input type="file" id="upfile" @change="upload" :accept="Types">
        </div>

        <div class="select" v-if="mode === 'select'">
            <div class="container">
                <div class="carousel">
                    <div class="inner" :style="{left: -index * 392 + 'px'}">
                        <div
                            class="preview"
                            v-for="(rows, j) of previews"
                            :key="'preview' + j"
                            @click="index = j"
                            :style="{cursor: index === j ? 'default' : 'pointer', opacity: index === j ? 1 : .5}"
                        >
                            <div class="u-row" @click.stop>
                                <ui-dropdown v-slot="{active, toggle}">
                                    <ui-select :class="{active}" :label="label(j)" @click.native="toggle" />
                                    <ui-options v-show="active" :options="categories(j)" @update="set" />
                                </ui-dropdown>
                            </div>

                            <div class="header row u-row">
                                <span class="w5 selected" v-if="header(j)">{{ header(j) }}</span>
                                <span v-else-if="hasHeader">{{ rows[0] }}</span>
                            </div>
                            <div class="scroll">
                                <div class="row u-row" v-for="(value, i) of rows.slice(hasHeader)" :key="'column' + i">
                                    <span>{{ value }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="dots">
                    <span class="dot" v-for="(_, i) of columns" :key="i" :class="{active: i === index}" @click="index = i" />
                </div>
            </div>

            <div class="notice t12 t-center" v-show="index === columns.length -1">
                ※既存のデータIDが含まれる場合、該当する物件データが上書きされますのでご注意ください。
            </div>

            <a class="btn primary" v-if="index === columns.length - 1" @click.stop="complete">
                <icon-import />
                インポートする
            </a>
            <a class="btn primary next" v-else @click.stop="index++">
                次へ進む
                <icon-arrow />
            </a>
        </div>

        <div class="complete t-center" v-if="mode === 'complete'">
            <div v-if="result && succeeded > 0">物件データ{{ succeeded }}件が正常に登録されました</div>
            <section v-if="result && result.failed.length">
                <b class="message u-row">
                    <icon-attention />
                    下記のデータは登録できませんでした
                </b>
                <div class="errors">
                    <div class="error" v-for="({code, indexes}, i) of errors" :key="'error' + i">
                        {{ Errors[code] }}
                        <div class="indexes" :title="detail(indexes)">
                            {{ detail(indexes) }}
                        </div>
                    </div>
                </div>
                <p>CSV・Excelのデータを修正し、再度アップロードしてください。</p>
            </section>
            <a class="btn secondary finish" @click="finish">
                閉じる
            </a>
        </div>

    </div>
</template>

<!--
    Scripts
-->

<script>

    import {mapActions} from 'vuex'

    import API from '@/common/modules/api'
    import Mime from '@/common/helpers/mime'

    import fields from '@/common/configs/fields'

    import uiLoader from '@/components/shared/ui/loader.vue'
    import uiDropdown from '@/components/shared/ui/dropdown.vue'
    import uiSelect from '@/components/shared/ui/select.vue'
    import uiOptions from '@/components/shared/ui/options.vue'
    import iconClose from '@/assets/icons/close.svg'
    import iconFile from '@/assets/icons/file.svg'
    import iconArrow from '@/assets/icons/big-arr-right.svg'
    import iconImport from '@/assets/icons/download.svg'
    import iconAttention from '@/assets/icons/attention.svg'
    import iconSuccess from '@/assets/icons/success.svg'


    const Configs = {
        upload: {
            title: '物件データのインポート',
            subtitle: 'CSVまたはXLSXファイルをアップロードしてください。'
        },
        select: {
            title: 'データの種別を設定する',
            subtitle: 'ファイルの列ごとに、データの種別を設定してください。',
            width: '660px'
        },
        complete: {
            title: '物件データのインポートが完了しました',
            width: '660px'
        }
    };

    const Errors = {};

    const Types = [
        '.csv',
        '.xls',
        '.xlsx',
        Mime.lookup('.csv'),
        Mime.lookup('.xlsx')
    ];


    export default {

        components: {
            uiLoader,
            uiDropdown,
            uiSelect,
            uiOptions,
            iconClose,
            iconFile,
            iconArrow,
            iconImport,
            iconAttention,
            iconSuccess
        },

        created () {
            Object.assign(this, {Errors, Types});
        },

        data () {
            return {
                mode: 'upload',
                loading: false,
                key: null,
                columns: [],
                hasHeader: true,
                previews: null,
                index: -1,
                result: null,
                skip: '一致するデータ種別がない'
            }
        },

        computed: {

            title () {
                return Configs[this.mode].title;
            },

            subtitle () {
                return Configs[this.mode].subtitle;
            },

            width () {
                return Configs[this.mode].width;
            },

            notfilled () {
                return this.columns.reduce((accum, value, i) =>
                    value === undefined ? accum.concat(i) : accum, []);
            },

            mapping () {
                return this.columns.reduce((accum, value, i) => {
                    const key = this.hasHeader ? this.previews[i][0] : i;
                    return value ? Object.assign(accum, {[key]: value}) : accum;
                }, {});
            },

            selected () {
                return this.columns[this.index] !== undefined;
            },

            succeeded () {
                return this.result.created + this.result.updated;
            },

            errors () {
                if (!this.result) return;
                const grouped = this.result.failed
                    .reduce((errors, error) => {
                        (errors[error.code] || (errors[error.code] = [])).push(error.index);
                        return errors;
                    }, {});
                return Object.keys(grouped).map(code => ({code, indexes: grouped[code]}));
            }

        },

        methods: {

            ...mapActions('toasts', [
                'info',
                'warn',
                'error'
            ]),

            fail () {
                this.error('インポートに失敗しました。時間を置いてもう一度お試しください。');
                this.$popup.hide();
            },

            header (i) {
                const key = this.columns[i];
                return key && fields[key];
            },

            categories (index) {
                const excluding = this.columns.filter((v, i) => i !== index && v);
                return fields
                    .values()
                    .filter(value => !excluding.includes(value))
                    .map(value => fields[value])
                    .concat(this.skip);
            },

            label (index) {
                return this.columns[index] !== undefined ?
                    fields[this.columns[index]] || this.skip : '選択してください';
            },

            detail (indexes) {
                return indexes.map(i => i + '行目').join('、');
            },

            set (label) {
                this.columns.splice(this.index, 1, fields[label] || null);
                if (this.index < this.columns.length - 1) this.index++;
            },

            infer (cols) {
                const keys = fields.values().filter(key => key !== 'id'),
                      names = fields.keys();
                cols.forEach((col, i) => {
                    const j = names.indexOf(col);
                    if (j > -1) {
                        this.columns.splice(i, 1, keys[j]);
                    }
                });
            },

            call (...args) {
                return this.loading = API(...args);
            },

            upload ({target}) {
                const [file] = target.files;
                const type = file.type || Mime.lookup(file.name) || 'text/csv';

                this.call('upload', file, type)
                    .then(({data: {key}}) => {
                        this.key = key;
                        return this.call('parse', key);
                    })
                    .then(({data}) => {
                        this.columns = [...new Array(data.columns.length)];
                        this.index = 0;
                        this.previews = data.rows;
                        this.infer(data.columns);
                        this.mode = 'select';
                    })
                    .catch(this.fail)
                    .finally(() => this.loading = null);
            },

            complete () {
                // if (this.columns.some(col => col === undefined)) {
                //     this.warn('すべての列のデータ種別を設定する必要があります');
                //     this.index = this.notfilled.length && this.notfilled[0] || 0;
                // }

                this.call('preimport', this.key, {mapping: this.mapping})
                    .then(({data: {key}}) => this.call('import', key))
                    .then(({data}) => {
                        this.mode = 'complete';
                        this.result = {
                            failed: [],
                            ...data
                        };
                    })
                    .catch(this.fail)
                    .finally(() => this.loading = null);
            },

            finish () {
                this.$popup.hide(true);
            }

        },

        destroy () {
            this.loading && API.abort(this.loading);
            this.previews = null;
        }

    }

</script>
